import { FC } from "react";
import { Link } from "react-router";
import classNames from "classnames";
import { useSelector } from "react-redux";

import Menu from "../Menu/Menu";
import { ERoutes } from "../../constants/routes";
import { SubscriptionPlan } from "@/constants/plans";
import MainBrandSelect from "../MainBrandSelect/MainBrandSelect";
import { selectAuthSubscriptionPlan, selectAuthIsManagedClient } from "../../store/selectors/auth";
import AgencySection from "./Components/AgencySection/AgencySection";
import ConfigWithAccordion from "./Components/ConfigWithAccordion/ConfigWithAccordion";

import styles from "./Sidebar.module.css";
import Skeleton from "../Skeleton/Skeleton";



const PLAN_CLASS_MAP: Record<SubscriptionPlan, string> = {
  [SubscriptionPlan.EssentialMonthly]: styles.plan_essential,
  [SubscriptionPlan.EssentialAnnual]: styles.plan_essential,
  [SubscriptionPlan.AdvancedMonthly]: styles.plan_advanced,
  [SubscriptionPlan.AdvancedAnnual]: styles.plan_advanced,
};

const PLAN_MAP = {
  [SubscriptionPlan.EssentialMonthly]: "Essential",
  [SubscriptionPlan.EssentialAnnual]: "Essential",
  [SubscriptionPlan.AdvancedMonthly]: "Advanced",
  [SubscriptionPlan.AdvancedAnnual]: "Advanced",
};

const Sidebar: FC = () => {
  const plan = useSelector(selectAuthSubscriptionPlan);
  const isManagedClient = useSelector(selectAuthIsManagedClient);
  const planName = plan && PLAN_MAP[plan];

  const renderPlan = () => {
    // Managed clients don't have their own subscription plan — agency pays
    if (isManagedClient) return null;
    if (!plan) return <Skeleton height={24} />;

    return (
      <div className={classNames(styles["sibedar__plan"], PLAN_CLASS_MAP[plan])}>
        <span className={styles["sibedar__plan_line"]} aria-hidden />
        <p>{planName} AI Plan</p>
        <span className={styles["sibedar__plan_line"]} aria-hidden />
      </div>
    );
  };  

  return (
    <div className={styles["sibedar"]}>
      <section className={styles["sibedar__section"]}>
        <div className={styles["sibedar__logo"]}>
          <Link to={ERoutes.Home}>
            <img src="/logo.svg" alt="Logo AICarma" />
          </Link>
        </div>
      </section>

      <section className={classNames(styles["sibedar__section"], styles["is-plan"])}>
        {renderPlan()}
      </section>

      <section className={styles["sibedar__section"]}>
        <div className={styles['sibedar__menu']}>
          <div className={styles['sibedar__menu-brand']}>
            <MainBrandSelect className={styles['sibedar__menu-brand-select']} />
          </div>
          <Menu />
        </div>
      </section>

      <section className={classNames(styles["sibedar__section"], styles["is-agency"])}>
        <AgencySection />
      </section>

      <section className={classNames(styles["sibedar__section"], styles["is-config"])}>
        <div className={styles['sibedar__menu']}>
          <ConfigWithAccordion />
        </div>
      </section>
    </div>
  );
};

export default Sidebar;

